import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { findVariableCatalogAct, loadVariableCatalogByIdAct, saveVariableCatalogAct, saveSuccessVariableCatalogAct, 
    setViolationsVariableCatalogAct, showMsgErrorAct, updateVariableCatalogAct, updateSuccessVariableCatalogAct } from "./variable-catalog.action";
import { VariableCatalogService } from "../../services/variable-catalog.service";



@Injectable()
export class VariableCatalogEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private variableCatalogService = inject(VariableCatalogService);
    private alerta = inject(AlertaService);

    findVariableCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findVariableCatalogAct),
            exhaustMap(action => this.variableCatalogService.findVariableCatalogById(action.id)
                .pipe(
                    map(variable => loadVariableCatalogByIdAct({ variable })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/variablesCatalog']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveVariableCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveVariableCatalogAct),
            exhaustMap(action => this.variableCatalogService.createVariableCatalog(action.variableNew)
                .pipe(
                    map(variableNew => saveSuccessVariableCatalogAct({ variableNew })),
                    /*catchError(error => (error.status == 400) ? of(setViolationsVariableCatalogAct({ variableForm: action.variableNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))*/
                    catchError(error => (error.status == 400) ? 
                        of(setViolationsVariableCatalogAct({ variableForm: action.variableNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                        : of(showMsgErrorAct({ error }))
                    //)
                    )
                )
            )
        )
    );

    /*showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            this.alerta.error("Se ha precentado un error interno");
        })
    ), { dispatch: false });*/
    showMsgErrorEffect$ = createEffect(() =>
            this.actions$.pipe(
              ofType(showMsgErrorAct),
              tap(action => {
                const detail = action.error?.error?.message || action.error?.message || null;
                //console.log('showMsgErrorEffect 111:');
                this.alerta.error(
                  'Se ha presentado un error interno Catalogo Beneficios',
                  detail ? { detail } : undefined
                );
                //console.log('showMsgErrorEffect 222:');
              })
            ),
            { dispatch: false }
          );

    saveSuccessVariableCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessVariableCatalogAct),
        tap(() => {
            this.router.navigate(['/variablesCatalog']);
            this.alerta.correct("Beneficio creado con exito!");
        })
    ), { dispatch: false });

    updateVariableCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateVariableCatalogAct),
            exhaustMap(action => this.variableCatalogService.updateVariableCatalog(action.variableUpdated)
                .pipe(
                    map(variableUpdated => updateSuccessVariableCatalogAct({ variableUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsVariableCatalogAct({ variableForm: action.variableUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessVariableCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessVariableCatalogAct),
        tap(() => {
            this.router.navigate(['/variablesCatalog']);
            this.alerta.correct("Beneficio editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
    
}